import React, { useEffect, useState } from "react";

// SUIR
import {
  Modal,
  Button,
} from "semantic-ui-react";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import axios from "axios";

const PhotoModal = ({ selectedFeature, open, setOpen, domain, token }) => {
  const [loading, setLoading] = useState(null);
  const [urls, setUrls] = useState([]);

  // console.log("PhotoModal", { urls });

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${domain}/apps/gma/property_photos/${selectedFeature.attributes.gid}`,
        {
          authenticity_token: token,
        }
      )
      .then((res) => {
        // console.error(res);
        if (res.data.files.length > 0) {
          setUrls(res.data.files);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setUrls([]);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return null;
  }

  return (
    <Modal onClose={() => setOpen(false)} open={true}>
      <Modal.Content style={{ textAlign: "center" }}>
        {urls.length === 0 && <p>No Images found for parcel</p>}
        {urls.length > 0 && (
          <ImageGallery
            showIndex={true}
            showPlayButton={false}
            showNav={false}
            items={urls.map((url) => {
              return {
                original: url,
                thumbnail: url,
              };
            })}
          />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={() => setOpen(false)}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default PhotoModal;
